import React, { useEffect } from 'react';
import { Carousel, CarouselControl, CarouselIndicators, CarouselItem, UncontrolledCarousel } from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { useState } from 'react';
import Main from './lis/Main';
import SomeFeatures from './lis/SomeFeatures';
import SampleManagement from './lis/SampleManagement';
import Adaptability from './lis/Adaptability';
import News from './lis/News';
import MainMobile from './lis/MainMobile';
import SomeFeaturesMobile from './lis/SomeFeaturesMobile';
import SampleManagementMobile from './lis/SampleManagementMobile';
import AdaptabilityMobile from './lis/AdaptabilityMobile';
import NewsMobile from './lis/NewsMobile';
import { Button } from 'reactstrap'


const useStyles = makeStyles((theme) => ({
    section: {
        height: '100vh',
    },
    buttonControl: {
        filter: 'invert(1)'
    },
    indicators: {
        filter: 'invert(1)'
    },

}));


const items = [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];

const slides = [
    { view: <Main /> },
    { view: <SomeFeatures /> },
    { view: <SampleManagement /> },
    { view: <Adaptability /> },
    { view: <News /> }].map((slide) =>
        <CarouselItem >
            {slide.view}
        </CarouselItem>);

const mobileSlides = [
    { view: <MainMobile /> },
    { view: <SomeFeaturesMobile /> },
    { view: <SampleManagementMobile /> },
    { view: <AdaptabilityMobile /> },
    { view: <NewsMobile /> }].map((slide) =>
        <CarouselItem >
            {slide.view}
        </CarouselItem>);

const LisCarrousel = ({ visible }) => {

    const classes = useStyles();
    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();
    const matchSM = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        setActiveIndex(0);
    }, [visible])

    const handleNext = (event) => {
        !isLastSlide && setActiveIndex(activeIndex + 1);
    }

    const handlePrev = () => {
        !isFirstSlide && setActiveIndex(activeIndex - 1);
    }

    const isFirstSlide = activeIndex === 0;
    const isLastSlide = activeIndex === (slides.length - 1);

    return (
        <div className={classes.section}>
            <Carousel
                activeIndex={activeIndex}
                next={function noRefCheck() { }}
                previous={function noRefCheck() { }}
            >
                <CarouselIndicators className={classes.indicators} items={items} activeIndex={activeIndex} onClickHandler={(index) => setActiveIndex(index)} />

                {matchSM ? mobileSlides : slides}


                {
                    !isFirstSlide &&
                    <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={handlePrev}
                        className={classes.buttonControl} />}

                {
                    !isLastSlide &&
                    <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={handleNext}
                        className={classes.buttonControl} />}

            </Carousel>
        </div>);
};

export default LisCarrousel;